import { useParams } from 'react-router';

import Stats from './Stats';
import Footer from './Footer';
import Header from './Header';
import Partners from './Partners';
import Subjects from './Subjects';
import NavBar from './NavBar';

export default function CatalogLayout() {
  const { subjectSlug } = useParams<{ subjectSlug?: string }>();
  const isLandingPage = !subjectSlug;

  return (
    <main style={{
      backgroundColor: '#1a1121',
      fontFamily: "'Open Sans', sans-serif",
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <NavBar />
      {isLandingPage ? (
        <>
          <Header />
          <Stats />
          {/* <Partners /> */}
        </>
      ) : (
        <div style={{ paddingTop: '5rem' }} />
      )}
      <div style={{ flex: 1 }}>
        <Subjects />
      </div>
      {
        isLandingPage && <Partners />
      }
      <Footer />
    </main>
  );
}
